{
    "NAME": "Benutzerliste Sprache",
    "UsersList_Column_FullName": "Vollständiger Name",
    "UsersList_Column_Username": "Benutzername",
    "UsersList_Column_LockOut": "Ausgesperrt",
    "UsersList_Column_ActivityLastLogon": "Aktivität\/Letzte Anmeldung",
    "UsersList_Tooltip_LastLogon_Label": "Letzter Login",
    "UsersList_LastLogon_None": "Keine Daten",
    "UsersList_Column_Permissions": "Berechtigungen",
    "UsersList_Column_TelSys": "Telefonieserver",
    "UsersList_LockOut_Yes": "Ja",
    "UsersList_LockOut_No": "NEIN",
    "UsersList_Filter_UserType_Label": "Benutzertyp",
    "UsersList_UserType_All": "Alle",
    "UsersList_UserType_ServiceWide": "Serviceweit",
    "UsersList_UserType_SystemWide": "Systemweit",
    "UsersList_UserType_Detached": "Losgelöst",
    "UsersList_UserType_AdminInclusive": "Administratoren (einschließlich)",
    "UsersList_UserType_AdminExclusive": "Administratoren (ausschließlich)",
    "UsersList_UserType_ReportingHistoricOnly": "Berichterstattung (nur historische Daten)",
    "UsersList_UserType_ReportingBLF": "Berichterstattung (BLF)",
    "UsersList_UserType_ReportingStd": "Berichterstattung (Standard)",
    "UsersList_UserType_ReportingACD": "Berichterstattung (ACD)",
    "UsersList_UserType_ReportingMobileAppAdvanced": "Berichtsfunktion (erweiterte mobile App)",
    "UsersList_UserType_SignedInNow": "Jetzt angemeldet",
    "UsersList_UserType_SignedInToday": "Heute angemeldet",
    "UsersList_UserType_SignedInThisWeek": "Diese Woche angemeldet",
    "UsersList_UserType_SignedInThisMonth": "In diesem Monat unterschrieben",
    "UsersList_UserType_SignedInNever": "Nie angemeldet",
    "UsersList_UserType_ActivityToday": "Aktivitäten heute",
    "UsersList_UserType_ActivityThisWeek": "Aktivitäten diese Woche",
    "UsersList_UserType_ActivityThisMonth": "Aktivitäten in diesem Monat",
    "UsersList_UserType_ActivityNone": "Keine Aktivität",
    "UsersList_CopyReports_Button": "Berichte kopieren nach",
    "UsersList_BulkAdd_Button": "Masseneinladung",
    "UsersList_SignInAs_Button": "Anmelden als",
    "UsersList_SignInAs_Confirm": "Anmelden als **{}**? Sie bleiben in dieser Browsersitzung als dieser Benutzer aktiv.",
    "UsersList_CopyReports_Dialog_Title": "Berichte kopieren von **{} ({})**",
    "UsersList_CopyReports_Step_Reports": "Berichte",
    "UsersList_CopyReports_Step_Targets": "Zielgruppe",
    "UsersList_CopyReports_Step_Confirm": "Bestätigen",
    "UsersList_CopyReports_Intro_Reports": "Wählen Sie einen oder mehrere Berichte zum Kopieren aus **{}** aus.",
    "UsersList_CopyReports_Intro_Targets": "Wählen Sie einen oder mehrere Benutzer aus, die Kopien dieser Berichte erhalten sollen.",
    "UsersList_CopyReports_Confirm_Summary": "Sie werden **{}** Berichte an **{}** Benutzer kopieren.",
    "UsersList_CopyReports_Confirm_Report_Label": "Kopiere **{}** Bericht:",
    "UsersList_CopyReports_Confirm_Reports_Label": "Kopieren von **{}** Berichten:",
    "UsersList_CopyReports_Confirm_Target_Label": "An **{}** Benutzer:",
    "UsersList_CopyReports_Confirm_Targets_Label": "An **{}** Benutzer:",
    "UsersList_CopyReports_Overwrite_Label": "Ersetzen Sie bestehende Berichte zu Zielbenutzern, wenn Namenskonflikte auftreten.",
    "UsersList_CopyReports_Success": "Berichte erfolgreich kopiert.",
    "UsersList_CopyReports_Cancel": "Stornieren",
    "UsersList_CopyReports_Back": "Zurück",
    "UsersList_CopyReports_Next": "Nächste",
    "UsersList_CopyReports_Copy": "Kopierberichte",
    "UsersList_CopyReports_Column_Folder": "Ordner",
    "UsersList_CopyReports_Column_ReportName": "Bericht",
    "UsersList_CopyReports_Column_Type": "Typ",
    "UsersList_CopyReports_Column_Username": "Benutzername",
    "UsersList_CopyReports_Column_FullName": "Vollständiger Name",
    "UsersList_CopyReports_Empty_Reports": "Für diesen Benutzer sind keine Berichte zum Kopieren verfügbar.",
    "UsersList_CopyReports_Empty_Targets": "Für diesen Kopiervorgang sind keine berechtigten Zielbenutzer vorhanden."
}